import { useNavigate } from "react-router-dom"

const radio = { borderRadius: '5px' }
function AddArtista() {
    const navigate = useNavigate()
    return (
        <>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', marginTop: '3em', gap: '18px', fontSize: 'medium', fontWeight: '600' }}>
                <button style={radio} onClick={() => { navigate('/addArtista') }}>AGGIUNGI UN ARTISTA
                </button>
                <button style={radio} onClick={() => { navigate('/addFoodTruck') }}>AGGIUNGI UN FODDTRUCK
                </button>
                <button style={radio} onClick={() => { navigate('/addFornitore') }}>AGGIUNGI ALLESTIMENTO</button>
            </div>
        </>
    )
}
export default AddArtista